/* stylelint-disable */
.range-info__container {
  background-color: #f7f7f7;
}

@media screen and (min-width: 980px) {
  .range-info__container {
    background-color: #ffffff;
  }
}

.range-info {
  margin: 0 auto;
}

.range-info .highlight-naming {
  font-weight: 400;
}

.range-info .highlight-naming .accent {
  font-weight: 700;
}

@media screen and (max-width: 979px) {
  .range-info {
    margin-bottom: 22px;
  }

  :host(:not([dir="rtl"])) .range-info {
    margin-left: 4px;
  }

  :host([dir="rtl"]) .range-info {
    margin-right: 4px;
  }
}

.range-info__cta-button-block {
  display: block;
}

@media screen and (max-width: 979px) {
  .range-info__cta-button-block {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  .range-info__wrapper {
    display: flex;
  }
}

.range-info__wrapper--desktop-only {
  display: none;
}

@media screen and (min-width: 980px) {
  .range-info__wrapper--desktop-only {
    display: flex;
  }
}

.range-info__title {
  margin-top: 0;
  margin-bottom: 16px;
  line-height: 2.8125rem;
  font-size: 2.1875rem;
  font-weight: 400;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .range-info__title {
    line-height: 3.125rem;
    font-size: 2.625rem;
  }
}

.range-info__slogan {
  font-size: 1.5625rem;
  font-weight: 400;
  line-height: 2.1875rem;
  margin-top: 0;
  margin-bottom: 16px;
}

@media screen and (min-width: 980px) {
  .range-info__slogan {
    color: #333333;
    font-size: 1.875rem;
    line-height: 2.5rem;
  }
}

.range-info__description {
  color: #626469;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0;
  margin-bottom: 5px;
}

@media screen and (min-width: 980px) {
  .range-info__description {
    font-size: 1.125rem;
    line-height: 1.875rem;
  }
}

.range-info__image {
  display: block;
  text-align: center;
  flex-grow: 1;
}

.range-info__image img {
  width: 190px;
  height: 190px;
}

@media screen and (min-width: 980px) {
  .range-info__image img {
    width: 260px;
    height: 260px;
  }
}

@media screen and (min-width: 980px) {
  .range-info_software__image img {
    width: 369px;
    height: 369px;
  }
}

.range-info__range-link {
  display: block;
  text-align: center;
  font-weight: 700;
  font-size: 0.8125rem;
  color: #42b4e6;
  text-decoration: none;
  position: relative;
}

@media screen and (min-width: 980px) {
  .range-info__range-link {
    display: none;
  }
}

.range-info__range-link::before {
  content: "<";
  padding: 5px;
}

.range-info__mobile-title {
  margin: 0;
  text-transform: capitalize;
  font-size: 1.625rem;
  font-weight: 100;
  line-height: 1.625rem;
}

@media screen and (min-width: 980px) {
  .range-info__mobile-title {
    display: none;
  }
}

.range-info .status-block {
  display: flex;
  flex-direction: column-reverse;
  margin: 24px 0;
}

@media screen and (min-width: 980px) {
  .range-info .status-block {
    flex-direction: row;
    margin-bottom: 10px;
  }
}

.range-info .status-block__brand-logo {
  margin-bottom: 12px;
}

@media screen and (min-width: 980px) {
  .range-info .status-block__brand-logo {
    margin-bottom: 0;
    padding-top: 4px;
  }

  :host(:not([dir="rtl"])) .range-info .status-block__brand-logo {
    margin-left: 0;
  }

  :host([dir="rtl"]) .range-info .status-block__brand-logo {
    margin-right: 0;
  }
}

.range-info .status-block__brand-logo img {
  height: 21px;
}

.range-info__info div.status-block__brand-logo {
  margin-bottom: 5px;
}

@media screen and (max-width: 979px) {
  .text-clamp {
    overflow: hidden;
    white-space: nowrap;
  }

  .blurred-text {
    box-shadow: white 0px -19px 9px 11px;
    z-index: 1;
    position: relative;
  }

  .hide-in-mobile {
    transition: opacity 0.5s, display 0.5s;
    display: none;
  }

  .commercial-status-mobile {
    display: block;
    padding: 20px 0px 0px;
    margin: 0px;
  }
}

.btn-readmore {
  font-size: 16px;
}

@media screen and (min-width: 980px) {
  .btn-readmore {
    display: none;
    animation: slideaway 200ms;
  }

  .commercial-status-mobile {
    display: none;
  }
}

.longDescription {
  display: inline;
}

.longDescription a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.longDescription a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.longDescription a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.longDescription a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.longDescription a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.longDescription a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.longDescription a[rel~=external] > .qds-external {
  display: inline-block;
}

.longDescription a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.longDescription a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}